module.exports = __webpack_public_path__ + "assets/share_arrow.ba88d58b.svg";